import React from "react";
import { Avatar, CardContent, Stack, Typography } from "@mui/material";
import { StyledCard } from "../styles";

const SummaryCard = ({ title, value, icon, color, bg }) => {
  return (
    <StyledCard
      elevation={0}
      sx={{
        height: "100%",
        background: bg,
      }}
    >
      <CardContent>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Avatar
            sx={{
              bgcolor: color,
              width: 42,
              height: 42,
            }}
          >
            {icon}
          </Avatar>

          <Stack>
            <Typography variant="h5" fontWeight={700}>
              {value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {title}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export default SummaryCard;
